import { useMediaQuery, useTheme } from "@mui/material";
import logo from "../assests/GroMedia.png"
const Footer = () => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(890));

    const styles = {
        container: {
            display: 'flex',
            justifyContent: 'center',
            background: '#000',
            paddingBottom: 40,
            paddingTop: 60,
            boxSizing: 'border-box',
            color: '#fff'
        },
        subContainer: {
            width: isMobile ? '90%' : '60%',
            textAlign: 'center',
            lineHeight: 1.5
        },
        logoContainer: {
            display: 'flex',
            justifyContent: 'center',
        },
        logo: {
            color: '#fff',
            fontSize: isMobile ? 30 : 40
        },
    }

    return (
        <div>
            <div style={styles.container}>
                <div style={styles.subContainer}>
                    {/* <div style={styles.logoContainer}>
                        <span style={styles.logo}>
                            <img src={logo} alt="logo" style={{ width: '100px', height: '100px' }} />
                        </span>
                    </div> */}

                    {/* <div>GrowMedia© is the trading name of Lemleaf Ventures Pvt Ltd.</div> */}

                    <div style={{ marginTop: 20 }}>This site is not part of the Facebook™ website or Facebook Inc. Additionally, this site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of FACEBOOK, Inc.</div>

                    <div style={{ marginTop: 20 }}>This site is not part of the Meta website or Meta Inc. Additionally, this site is NOT endorsed by Meta in any way. META™ is a trademark of META, Inc</div>

                    <div style={{ marginTop: 20 }}>All Rights Reserved | All Wrongs Reversed</div>
                </div>
            </div >
            {/* <div style={{ fontSize: '14px', borderTop: '1px solid #263041', background: 'black', display: 'flex',flexDirection: isMobile ? 'column' : 'row', alignItems: 'center',gap:10, justifyContent: 'space-around', color: 'white', padding: '20px', boxSizing: 'border-box' }}>
                <div>Terms | Disclaimer Privacy</div>
                <div>Copyright 2024: GrowMedia</div>
                <div>Designed by Zeegens Technologies</div>
            </div> */}
        </div >

    )



}



export default Footer;